<template>
  <Dialog
    :modal="true"
    v-model:visible="showDialog"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    :header="
      model ? $t('stores.Box.EditFormHeader') : $t('stores.Box.FormHeader')
    "
    @after-hide="IsClear"
  >
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              v-model="dataModel.BoxName"
              type="text"
              placeholder=" "
              clearable
              name="Box Name"
              :label="$t('box.name')"
              :rules="{ required: true }"
              id="Box Name"
              :required-icon="true"
              case="Capital"
              :autofocus="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <StoreDropDown
              v-model="SelectOption.StoreId"
              :items="SelectOption.StoreOptions"
              @update:modelValue="
                () => {
                  SelectStore(SelectOption.StoreId), LoadRoom();
                }
              "
              :label="$t('box.SMapping')"
              :rules="{ required: true }"
              name="Store Mapping"
              id="Store Mapping"
              :required-icon="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8" class="addcircle_field">
          <div class="field">
            <CustomDropDown
              v-model="SelectOption.RoomId"
              :items="SelectOption.RoomOption"
              @update:modelValue="LoadRack"
              :label="$t('rack.RoomMapping')"
              :rules="{ required: true }"
              name="Room Mapping"
              id="Room Mapping"
              :required-icon="true"
            />
          </div>
          <span
            class="add_circle"
            @click="FunctionRights(EntityIds.Room, 'Room')"
            ><i class="pi pi-plus"></i
          ></span>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8" class="addcircle_field">
          <div class="field">
            <CustomDropDown
              v-model="SelectOption.RackId"
              :items="SelectOption.RackOptions"
              @update:modelValue="LoadRow"
              :label="$t('box.RackMapping')"
              :rules="{ required: true }"
              name="Rack Mapping"
              id="Rack Mapping"
              :required-icon="true"
            />
          </div>
          <span
            class="add_circle"
            @click="FunctionRights(EntityIds.Rack, 'Rack')"
            ><i class="pi pi-plus"></i
          ></span>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8" class="addcircle_field">
          <div class="field">
            <CustomDropDown
              v-model="SelectOption.RowId"
              :items="SelectOption.RowOption"
              :label="$t('rack.RowMapping')"
              :rules="{ required: true }"
              name="Row Mapping"
              id="Row Mapping"
              :required-icon="true"
            />
          </div>
          <span class="add_circle" @click="FunctionRights(EntityIds.Row, 'Row')"
            ><i class="pi pi-plus"></i
          ></span>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              v-model="dataModel.Capacity"
              type="text"
              placeholder=" "
              clearable
              name="Capacity"
              :label="$t('box.Capacity')"
              :rules="{ required: true, numeric: true }"
              id="Capacity"
              :required-icon="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <Footer
            @cancel="IsClear()"
            :cancelhide="false"
            :label="label"
            :loading="Saveloader"
          />
        </b-col>
      </b-row>
    </b-form>
  </Dialog>

  <RoomCreation
    v-if="DialogShow.Room"
    @close="DialogShow.Room = false"
    @loaderhide="loading = false"
    @loadershow="loading = true"
    :OperationID="ObjOperationId"
    :EntityId="EntityIds.Room"
  />

  <RackModal
    v-if="DialogShow.Rack"
    @close="DialogShow.Rack = false"
    @loaderhide="loading = false"
    @loadershow="loading = true"
    :OperationID="ObjOperationId"
    :EntityId="EntityIds.Rack"
  />

  <RowCreation
    v-if="DialogShow.Row"
    @close="DialogShow.Row = false"
    @loaderhide="loading = false"
    @loadershow="loading = true"
    :OperationID="ObjOperationId"
    :EntityId="EntityIds.Row"
  />
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  PropType,
  watch,
  onMounted,
} from "vue";
import RoomCreation from "../../../Masters/Stores/RoomMaster/RoomCreation.vue";
import RowCreation from "../../../Masters/Stores/RowMaster/RowCreation.vue";
import RackModal from "../../../../pages/Masters/Stores/RackMaster/RackCreation.vue";
import MastersService from "../../../../Service/MastersService";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import CustomDropDown from "../../../../../../components/FormComponents/Dropdown.vue";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import storeService from "../../../../Service/StoreService";
import commonservice from "../../../../Service/BoxService";
import RackService from "../../../../Service/RackService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";

import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import roomService from "../../../../Service/RoomService";
import RowService from "../../../../Service/RowService";

import Loader from "../../../../../../components/FormComponents/Loader.vue";
import { checkPermission } from "../../../../Service/AccessControl";
import moment from "moment";
import { useToast } from "primevue/usetoast";
import StoreDropDown from "../../../../../../modules/Inventory/components/DropDown/StoreDropDown.vue";
export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
  },
  components: {
    RowCreation,
    RackModal,
    RoomCreation,

    Footer,
    CustomDropDown,

    TextField,
    CreateSuccessully,
    UpdatedSuccessfully,
    AlreadyExist,
    Loader,
    StoreDropDown,
  },
  setup(props, { emit }) {
    /*Declaration starts*/
    const showDialog = ref(false);
    debugger;
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    const model: any = ref(props.selectedItem);
    let loading = ref(false);
    let Saveloader = ref(false);
    const toast = useToast();
    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }

    const dataModel = ref({
      BoxName: "",
      StoreId: 0,
      RoomId: 0,
      RackId: 0,
      RowId: 0,
      Id: 0,
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      EntityId: 0,
      EntityOperationId: 0,
      Capacity: "",
      StoreBrMapId: 0,
    });
    const copydataModel = JSON.parse(JSON.stringify(dataModel.value));

    const SelectOption = ref({
      StoreId: ref(),
      StoreOptions: [],
      RackId: ref(),
      RackOptions: [],
      RoomId: ref(),
      RoomOption: [],
      RowId: ref(),
      RowOption: [],
    });
    const copySelectOption = JSON.parse(JSON.stringify(SelectOption.value));
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const successpop = ref(false);
    const updatepop = ref(false);
    const alreadyexistpop = ref(false);
    //Session Hospital&Branch ID
    let session: any = localStorage.getItem("UsersData");
    let DialogShow = ref({
      Room: false,
      Rack: false,
      Row: false,
    });

    let EntityIds = ref({
      Room: 98,
      Rack: 99,
      Row: 100,
    });
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Entitydata = ref();
    Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = JSON.parse(Entitydata.value);
    /*Declaration ends*/
    /* Methods Starts */
    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
    });
    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;
      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false &&
          alreadyexistpop.value == false)
      ) {
        IsClear();
      }
      // else if (event.altKey && event.key == 'n') {
      //     showDialog.value = true;
      // }
      else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }

    function SelectStore(value) {
      if (value) {
        let store: any = SelectOption.value.StoreId.Id;
        dataModel.value.StoreId = store;
        dataModel.value.StoreBrMapId =
          SelectOption.value.StoreId.StoreBranchMapId;
        dataModel.value.BranchId = SelectOption.value.StoreId.BranchId;
      }
    }

    //Add Click Function
    function IsCreate() {
      debugger;
      showDialog.value = true;
    }
    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    const copyRights = JSON.parse(JSON.stringify(Rights.value));
    const copyObjOperationId = JSON.parse(JSON.stringify(ObjOperationId.value));
    //FunctionRights for adding room,rack
    async function FunctionRights(EntityId, FieldType) {
      debugger;
      Object.assign(Rights.value, copyRights);
      Object.assign(ObjOperationId.value, copyObjOperationId);
      const response = await MastersService.CheckMenuRights(
        EntityId,
        rolesData.RoleId
      );
      console.log("FunctionRights:" + response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        DialogShow.value[FieldType] = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    //Store  Select Load function
    async function LoadStore() {
      try {
        const result = await storeService.getStoreList(HospitalId, BranchId);
        console.log(result);
        SelectOption.value.StoreOptions = result["result"]
          .filter(
            (i1) =>
              i1.IsActive == true &&
              i1.HospitalId == HospitalId &&
              i1.BranchId == BranchId
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {}
    }

    //Room Load Based on Store
    async function LoadRoom() {
      debugger;
      try {
        SelectOption.value.RoomId = null;
        SelectOption.value.RackId = null;
        SelectOption.value.RowId = null;
        SelectOption.value.RoomOption = [];
        console.log(SelectOption.value.StoreId);
        const result = await roomService.getRoomByStoreId(
          dataModel.value.StoreId,
          dataModel.value.StoreBrMapId
        );
        console.log(result);
        SelectOption.value.RoomOption = result["result"]
          .filter((i1) => i1.IsActive == true)
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {}
    }

    //Rack Load by Room Id
    async function LoadRack() {
      debugger;
      try {
        SelectOption.value.RackId = null;
        SelectOption.value.RowId = null;
        let Id = SelectOption.value.RoomId;
        const result = await RackService.getRackByRoomId(Id);
        console.log(result);
        SelectOption.value.RackOptions = result["result"]
          .filter((i1) => i1.IsActive == true)
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {}
    }
    //Row Load by Rack Id
    async function LoadRow() {
      debugger;
      try {
        SelectOption.value.RowId = null;
        let Id = SelectOption.value.RackId;
        const result = await RowService.getRowByRackId(Id);
        console.log(result);
        SelectOption.value.RowOption = result["result"]
          .filter((i1) => i1.IsActive == true)
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {}
    }
    //Insert Update
    const IsSubmit = async () => {
      emit("loadershow");
      debugger;
      Saveloader.value = true;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloader.value = false;
        return;
      }

      let room: any = SelectOption.value.RoomId;
      dataModel.value.RoomId = room;
      let rack: any = SelectOption.value.RackId;
      dataModel.value.RackId = rack;
      let row: any = SelectOption.value.RowId;
      dataModel.value.RowId = row;
      console.log(dataModel.value.StoreId);
      dataModel.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      dataModel.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      //dataModel.value.BranchId = BranchId
      dataModel.value.HospitalId = HospitalId;
      dataModel.value.ModifiedBy = UserId;
      dataModel.value.CreatedBy = UserId;
      dataModel.value.EntityId = Number(Entitydata.value.EntityId);

      try {
        let result: any;
        let msg = "";
        if (dataModel.value.Id != 0) {
          dataModel.value.EntityOperationId = props.OperationID.UpdateId;
          result = await commonservice.updateBox(dataModel.value);

          msg = result["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (result["result"] == "Already" && msg == null) {
            Saveloader.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloader.value = false;
            updatepop.value = true;
          } else {
            Saveloader.value = false;
            alert("something went wrong");
          }
        } else {
          dataModel.value.EntityOperationId = props.OperationID.CreateId;
          result = await commonservice.insertBox(dataModel.value);

          msg = result["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (result["result"] == "Already" && msg == null) {
            Saveloader.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloader.value = false;
            successpop.value = true;
          } else {
            Saveloader.value = false;
            alert("something went wrong");
          }
        }

        if (msg == null) {
        }
      } catch (error) {
        emit("loaderhide");
        Saveloader.value = false;
      }
    };
    //Edit Box
    async function IsEdit() {
      showDialog.value = true;
      emit("loadershow");
      debugger;
      try {
        //dataModel.value.Id = model.value.Id;
        label.value = t("btn.update");
        const result = await commonservice.getBoxById(model.value.Id);
        let resfields = result["result"];
        Object.keys(dataModel.value).forEach((key) => {
          if (resfields[key]) dataModel.value[key] = resfields[key];
        });
        // SelectOption.value.StoreId = resfields.StoreId;
        SelectOption.value.StoreId = resfields.StoreBrMapId;
        LoadRoom();
        SelectOption.value.RoomId = resfields.RoomId;
        LoadRack();
        SelectOption.value.RackId = resfields.RackId;
        LoadRow();
        SelectOption.value.RowId = resfields.RowId;

        dataModel.value.CreatedAt = "2023-02-03T11:05:31.945Z";
        dataModel.value.StoreId = resfields.StoreId;
        dataModel.value.StoreBrMapId = resfields.StoreBrMapId;
        emit("loaderhide");
      } catch (error) {
        emit("loaderhide");
      }
    }
    //Clear
    function IsClear() {
      debugger;
      Object.assign(dataModel.value, copydataModel);
      Object.assign(SelectOption.value, copySelectOption);
      console.log(dataModel.value);
      LoadStore();
      showDialog.value = false;
      emit("update:selectedItem", undefined);
      emit("close");
    }
    /*Methods End*/

    //Created Sucessfully Popup-Close
    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      showDialog.value = false;
      emit("load");
      IsClear();
    }
    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      dataModel.value.BoxName = "";
    }

    return {
      EntityIds,

      showDialog,

      handleValidateButtonClick() {
        emit("clicked");
      },
      IsSubmit,
      showModal: ref(false),
      dataModel,
      SelectOption,
      LoadStore,
      IsEdit,
      IsClear,
      LoadRack,
      IsCreate,
      alreadyexistpop,
      successpop,
      updatepop,
      closetrigger,
      alreadyclosetrigger,
      FunctionRights,
      LoadRoom,
      LoadRow,
      label,
      loading,
      DialogShow,
      ObjOperationId,
      model,
      SelectStore,
      Saveloader,
    };
  },
  async created() {
    this.LoadStore();
  },
});
</script>
